export default {"src":"/org/_next/static/media/checklist.077dd4fe.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};